<template>
  <div class="paint">
    <div style="display:flex; justify-content: center;">
      <p>"Ma grand-mère regardait toujours ces tableaux lorsqu'elle nous racontait ses histoires. Je suis content de les avoir conservés. Elle nous disait que seuls ceux qui connaissaient le Comte et surtout l'adresse de son château pouvaient en comprendre le message..."</p>
    </div>
    <div class="center-text full-width">
      <img src="../../../assets/NewYear/Paint-2.png" />
      <br />
      <br />
      <img src="../../../assets/NewYear/Paint-1.png" />
    </div>
    <br />
    <div class="hints">
      <div v-for="(hint, index) in reduceList" :key="index">
        <button
          :class="getClass(hint, index)"
          @click="display(hint.id)"
          :disabled="getClass(hint, index) === 'inactive' "
        >💡 #{{index + 1}}</button>
      </div>
    </div>
    <div v-for="(hint, index) in reduceList" :key="index">
      <hint
        v-if="hint.display"
        :content="hint.content"
        :index="index"
        :read="hint.read"
        @close="closeHints()"
        @continue="increment(hint.id)"
      />
    </div>
  </div>
</template>

<script>
import Hint from "../../shared/Hint";

export default {
  props: {
    hintList: Array
  },
  components: {
    Hint
  },
  data() {
    return {
      hints: this.hintList,
      reduceList: this.hintList.filter(h => h.vue === "paint")
    };
  },
  methods: {
    closeHints() {
      this.hints.forEach(h => {
        h.display = false;
      });
    },
    display(id) {
      this.closeHints();
      this.hints.find(h => h.id === id).display = true;
    },
    getClass(hint, index) {
      if (this.hints.find(h => h.id === hint.id).read) return "read";
      if (index === 0) return "active";
      if (this.reduceList[index - 1].read) return "active";
      return "inactive";
    },
    increment(id) {
      this.hints.find(h => h.id === id).read = true;
      this.$emit("updateHints", this.hints);
      this.$emit("incrementCounter");
    }
  }
};
</script>

<style scoped>
h1 {
  font-family: "Playfair Display", serif;
  font-weight: bold;
  color: rgb(35, 35, 35);
  font-size: 300%;
  margin-top: 0;
  border-bottom: double rgb(35, 35, 35);
  width: 100%;
}
p,
a {
  color: rgb(35, 35, 35);
  font-family: "Playfair Display", serif;
  font-size: 16px;
}
em {
  font-size: 40%;
  color: #ebc134;
}
.center-text {
  text-align: center;
}
.full-width {
  width: 100%;
}
.paint {
  font-family: "Playfair Display", serif;
  text-align: center;
  height: 100vh;
  overflow: scroll;
}
.paint img {
  width: 50%;
  border: 10px solid #0c3e6c;
}
.paint p {
  font-family: "Kalam", cursive;
  background: rgb(240, 240, 240);
  font-size: 100%;
  width: 80%;
  padding: 15px;
  border-radius: 30px;
}
.hints {
  /* position: absolute; */
  margin-bottom: 3%;
  width: 100%;
  display: flex;
  justify-content: space-evenly;
}
.hints button {
  font-family: "IBM Plex Mono", monospace;
  font-weight: bold;
  border: none;
  border-radius: 3px;
}
.hints button:focus {
  outline: none;
}
.inactive {
  cursor: not-allowed;
  background: #ce322c;
  color: rgb(235, 235, 235);
}
.active {
  cursor: pointer;
  background: #faa806;
  color: rgb(235, 235, 235);
}
.read {
  cursor: pointer;
  background: #01593b;
  color: rgb(235, 235, 235);
}
</style>
